module.exports = __webpack_public_path__ + "static/img/iDrivee2.db4c43c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/iDrivee2.svg
// module id = Ke33
// module chunks = 1